import { createElement } from 'react';
import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { companyLogos } from '@/components/common/CompanyLogos';
import { RichHeading } from '@/components/common/Heading';
import { HeadingLevel } from '@/components/common/MarkUp';
import { Stack } from '@/components/layout/Stack';

import type { Heading } from '@/types/shared';

type Company = { _type?: string; _key?: string; logo?: { name?: string } };
export interface PartnerLogosProps {
  heading: Heading;
  logos: Company[];
}

const Logo = ({ name }) => {
  const logoComponent = companyLogos[name];
  return <LogoWrapper>{createElement(logoComponent)}</LogoWrapper>;
};

export const PartnerLogos = ({ heading, logos }: PartnerLogosProps) => {
  return (
    <StyledStack spacing="--space-component-xl">
      {heading && (
        <HeadingLevel>
          <RichHeading
            size="label-md"
            elementType="paragraph"
            heading={heading}
          />
        </HeadingLevel>
      )}

      <LogosContainer>
        {logos.map((company) => {
          return <Logo key={company.logo.name} name={company.logo.name} />;
        })}
      </LogosContainer>
    </StyledStack>
  );
};

const StyledStack = styled(Stack)`
  p {
    color: var(--text-warm-base);
  }
`;

const LogoWrapper = styled.div`
  > svg {
    height: 40px;
    opacity: 64%;
    ${screen.lg} {
      height: 48px;
    }
  }
`;

const LogosContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  row-gap: var(--space-component-xl);
  column-gap: var(--space-component-xxl);
  justify-content: flex-start;
`;
